<template>
  <div class="cart-carousel">
    <div
      class="cart-carousel-content"
      ref="scrollContainer"
    >
      <div class="cart-carousel-item">
        <img
          src="@/assets/colorIcon/secure.svg"
          alt=""
          style="width: 24px;"
        >
        <p>
          <span class="cart-carousel-buyer">BUYER</span>
          <span class="cart-carousel-guarantee">&nbsp;GUARANTEE</span>
          <span class="cart-carousel-purchase">Secure Payments</span>
        </p>
      </div>
      <div class="cart-carousel-item">
        <img
          src="@/assets/colorIcon/coupon.svg"
          alt=""
          style="width: 20px;"
        >
        <span class="cart-carousel-more">More You Buy, More You Save</span>
      </div>
    </div>
    <img
      class="cart-carousel-item__icon"
      src="@/assets/order/official-security2.svg"
      alt=""
    >
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'

const scrollContainer = ref(null)
let intervalId

onMounted(() => {
  startScrolling()
})

onUnmounted(() => {
  clearInterval(intervalId)
})

const startScrolling = () => {
  const container = scrollContainer.value
  const contentHeight = 40 // 每个滚动项的高度
  let scrollPosition = 0

  // 复制第一个元素，实现无缝滚动
  const firstItem = container.children[0].cloneNode(true)
  container.appendChild(firstItem)

  intervalId = setInterval(() => {
    scrollPosition += contentHeight
    container.style.transition = 'transform 1s ease-in-out'
    container.style.transform = `translateY(-${scrollPosition}px)`

    if (scrollPosition >= contentHeight * (container.children.length - 1)) {
      setTimeout(() => {
        container.style.transition = 'none' // 取消动画，瞬间回到初始位置
        container.style.transform = 'translateY(0)'
        scrollPosition = 0
      }, 1000)
    }
  }, 5000)
}
</script>

<style lang="less" scoped>
.cart-carousel {
  padding: 0 16px;
  height: 40px;
  background: #F4F7FF;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  &-content {
    display: flex;
    flex-direction: column;
    height: 40px;
    width: 100%;
    line-height: 40px;
  }

  &-item {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    height: 40px;
    font-size: 12px;
    font-family: mon-600;
    color: #232323;

    @media (min-width: 1024px) {
      justify-content: flex-start;
    }

    &__icon {
      display: none;
      margin-left: auto;
      width: 40px;

      @media (min-width: 1024px) {
        display: block;
      }
    }
  }

  &-buyer {
    font-size: 13px;
    font-family: mon-700;
    color: #1153D6;
  }

  &-guarantee {
    color: #f57232;
    font-family: mon-700;
  }

  &-purchase {
    margin-left: 6px;
  }

  &-more {
    background: linear-gradient(90deg, #1153D6 0%, #F55745 100%);
    background-clip: text;
    -webkit-background-clip: text;
    color: transparent;
  }
}
</style>
